interface Props {
  n: number
}

export default function StepBadge({ n }: Props) {
  return (
    <div className="w-7 h-7 rounded-full bg-brand flex items-center justify-center text-white text-sm font-bold shrink-0">
      {n}
    </div>
  )
}
